<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Feedbacks",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Feedbacks",
            items: [
               
               {
                  text: "Feedbacks",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            from: null,
            to: null,
            total: null,
            pagination: {},

            feedbacks: [],
            token: '',
            errors: {},

            feedback: '',
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchFeedbacks();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         fetchFeedbacks(page_url = null) {

            this.getToken();
            let url = "api/admin/feedback?keyword=" + this.keyword + "&limit=" + this.listing_length;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.feedbacks = responseData.feedback.data;
                  
                  this.pagination = responseData.feedback.links;
                  this.from = responseData.feedback.from;
                  this.to = responseData.feedback.to;
                  this.total = responseData.feedback.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         viewFeedback(feedback) {
            this.feedback = feedback.message;
            this.showModal("feedback-modal");
         },

         clearForm() {
            this.feedback = '';
         }
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">                    

                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchFeedbacks()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchFeedbacks()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="10%">User</th>                 
                              <th width="10%">User Type</th>
                              <th width="20%">Feedback</th>
                              <th width="20%">Posted on</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(feedbacks.length)">
                           <tr v-for="(feedback) in feedbacks" :key="feedback.id">
                              <td>
                                 <span v-if="feedback.user_type==2">Dr. {{feedback.doctor_name}}</span>
                                 <span v-if="feedback.user_type==3">{{feedback.patient_name}}</span>
                                 <span v-if="feedback.user_type==4">{{feedback.clinic_name}}</span><br>
                                 {{feedback.country_code}}{{feedback.mobile}}<br>{{feedback.email}}
                              </td>
                              <td>
                                 <span v-if="feedback.user_type==2">Doctor</span>
                                 <span v-if="feedback.user_type==3">Patient</span>
                                 <span v-if="feedback.user_type==4">Patient</span>
                              </td> 
                              <td>{{feedback.message | excerpt(50)}} <br><!-- <a href="#" @click.prevent="" v-b-modal.feedback-modal>Read More</a> --><a href="#" v-if="feedback.message.length > 50" @click.prevent="viewFeedback(feedback)" >Read More</a></td>               
                              
                              <td>{{feedback.created_at | formatDateTime}}</td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No feedbacks found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(feedbacks.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchFeedbacks(page.url + '&limit='+ listing_length + '&keyword=' + keyword )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                  <b-modal ref="feedback-modal" id="feedback-modal" title="View Feedback" hide-footer @hidden="clearForm()">
                     <b-form>
                        
                        <b-col md="12">
                           <card class="p-3">
                              <p>{{feedback}}</p>
                           </card>
                        </b-col>                   
                        
                        <b-col md="12">                           
                           <b-button class="" variant="light" @click="$bvModal.hide('feedback-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
